import { IOptionProps } from '@amobee/component-library';
import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { TimeFrame } from 'src/app/planner/enums/TimeFrame.enum';

@Component({
  selector: 'frequency-cap',
  templateUrl: './frequency-cap.component.html',
  styleUrls: ['./frequency-cap.component.scss']
})
export class FrequencyCapComponent implements OnInit {
  @Input() group: string;
  @Input() formArray: FormArray;
  timeFrames = TimeFrame;

  constructor() { }

  ngOnInit() {
  }

  handleOnSelectChange(event: IOptionProps) {
    this.timeFrame.patchValue(event.value);
  }

  get frequencyCap(): FormControl {
    return this.formArray.controls[this.group].get('frequencyCap');
  }

  get timeFrame(): FormControl {
    return this.frequencyCap.get('timeFrame') as FormControl;
  }

}
